(function () {
  /** @type {WeakMap<HTMLElement, any>} */
  const initializedCarousels = new WeakMap();

  /**
   * @param {HTMLElement} viewport
   */
  function initCarousel(viewport) {
    if (!viewport) return;
    if (initializedCarousels.has(viewport)) return;

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(viewport), 100);
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const embla = EmblaCarousel(viewport, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: 1,
      dragFree: false,
      duration: reducedMotion ? 0 : 25
    });

    initializedCarousels.set(viewport, embla);
    // Exposed for the Slider with switcher section, which has to re-measure
    // and rewind a carousel when its hidden panel is shown.
    /** @type {any} */ (viewport).emblaApi = embla;

    const carousel = viewport.closest('.ps__carousel');
    const prevButton = /** @type {HTMLButtonElement | null} */ (carousel?.querySelector('.ps__arrow--prev'));
    const nextButton = /** @type {HTMLButtonElement | null} */ (carousel?.querySelector('.ps__arrow--next'));
    const dotsContainer = carousel?.querySelector('.ps__dots');

    // One dot per scroll snap, not per slide: with containScroll trimSnaps the
    // snap list already collapses to the number of scrollable positions.
    const setupDots = () => {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';
      embla.scrollSnapList().forEach((/** @type {number} */ _, /** @type {number} */ index) => {
        const dot = document.createElement('button');
        dot.className = 'ps__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Ga naar slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsContainer.appendChild(dot);
      });
    };

    const updateDots = () => {
      if (!dotsContainer) return;

      const selectedIndex = embla.selectedScrollSnap();
      dotsContainer.querySelectorAll('.ps__dot').forEach((/** @type {Element} */ dot, /** @type {number} */ index) => {
        dot.classList.toggle('ps__dot--active', index === selectedIndex);
        if (index === selectedIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const updateButtons = () => {
      if (prevButton) prevButton.disabled = !embla.canScrollPrev();
      if (nextButton) nextButton.disabled = !embla.canScrollNext();
    };

    if (prevButton) prevButton.addEventListener('click', () => embla.scrollPrev());
    if (nextButton) nextButton.addEventListener('click', () => embla.scrollNext());

    embla.on('select', () => {
      updateDots();
      updateButtons();
    });

    // reInit fires on resize; the snap count can change with it.
    embla.on('reInit', () => {
      setupDots();
      updateDots();
      updateButtons();
    });

    setupDots();
    updateDots();
    updateButtons();
  }

  function initAllCarousels() {
    document.querySelectorAll('.ps__viewport:not([data-initialized])').forEach((/** @type {Element} */ viewport) => {
      if (viewport instanceof HTMLElement) {
        viewport.setAttribute('data-initialized', 'true');
        initCarousel(viewport);
      }
    });
  }

  function handleThemeEditorUpdates() {
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initAllCarousels);
      document.addEventListener('shopify:section:reorder', initAllCarousels);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      handleThemeEditorUpdates();
    });
  } else {
    initAllCarousels();
    handleThemeEditorUpdates();
  }
})();
